import styles from './DataLoader.module.css';

export default function DataLoader() {
    return <span className={styles.Loader}></span>;
}
